import { ScheduleV2 } from "../../../types";

export interface ScheduleEmpDetailsProps {
    schedule: ScheduleV2;
}

const ScheduleEmpDetails: React.FC<ScheduleEmpDetailsProps> = ({ schedule }) => {

    if(!schedule?.emp_details) return null;

    const { emp_name } = schedule.emp_details;

    return (
        <div className="border rounded-lg p-4 bg-gray-50 shadow">
            {/* <h3 className="text-sm font-semibold text-gray-700">Employee</h3> */}
            {emp_name && (<p className="text-sm text-gray-500">{emp_name}</p>)}
            {/* <p className="text-sm text-gray-500">Position: {schedule?.workcode?.workcode_name}</p> */}
        </div>
    );
};


export default ScheduleEmpDetails;
